/**
 * Pure iOS detection from a user-agent string. Catches iPhone/iPod and iPads
 * that still report the legacy mobile UA. iPadOS 13+ desktop-mode Safari reports
 * a macOS UA with no iPad token — detect that case with isIPadOSDesktop().
 * @param {string} userAgent
 * @returns {boolean}
 */
export function isIOSUserAgent(userAgent) {
  return /iPad|iPhone|iPod/.test(userAgent ?? '')
}

/**
 * iPadOS 13+ Safari reports a macOS desktop user agent (no iPad/Mobile token),
 * so it can't be detected from the UA string alone. The reliable tell is a Mac
 * user agent that also reports multi-touch: real Macs report 0 touch points,
 * iPads report 5. `maxTouchPoints` is only available client-side.
 * @param {string} userAgent
 * @param {number} [maxTouchPoints] navigator.maxTouchPoints
 * @returns {boolean}
 */
export function isIPadOSDesktop(userAgent, maxTouchPoints) {
  return /Macintosh/.test(userAgent ?? '') && (maxTouchPoints ?? 0) > 1
}

/**
 * Chrome on iOS. WebKit-based like Safari, but ships its own browser UI whose
 * bugs need Chrome-specific handling; Safari never reports the CriOS token.
 * @param {string} userAgent
 * @returns {boolean}
 */
export function isCriOSUserAgent(userAgent) {
  return /CriOS/.test(userAgent ?? '')
}
